"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = Link;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./Link.css"));
var _uiKit = require("@cian/ui-kit");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Link(_ref) {
  let {
    href,
    children,
    target,
    onClick,
    title,
    disabled,
    dataMark,
    responsive
  } = _ref;
  const linkRel = target === '_blank' ? 'noreferrer' : undefined;
  const deviceType = (0, _uiKit.useDeviceType)();
  const handleClick = React.useCallback(e => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (!onClick) {
      return;
    }
    onClick(e);
  }, [onClick, disabled]);
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    className: (0, _classnames.default)(styles['link'], {
      [styles['link-disabled']]: disabled,
      [styles[`link--${deviceType}`]]: responsive
    }),
    target: target,
    title: title,
    rel: linkRel,
    onClick: handleClick,
    "data-mark": dataMark || 'Link'
  }, children);
}